import React from 'react'

import { Loading } from '@components/Loading'

import { Icon, Message, NoContentContainer } from './styles'

interface INoContentProps {
  type: 'barriers' | 'comments' | 'loading' | 'resources'
  backgroundColor: string
  message?: string
}

export function NoContent({ type, message = '', ...rest }: INoContentProps) {
  return (
    <NoContentContainer {...rest}>
      {type === 'barriers' && <Icon name="engineering" />}
      {type === 'resources' && <Icon name="people" />}
      {type === 'loading' && <Loading />}
      <Message>{message}</Message>
    </NoContentContainer>
  )
}
